import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function Box({ children, className }: props) {
  return (
    <div className={classNames('Box', 'uk-tile uk-tile-default', className)}>
      {children}
    </div>
  )
}

Box.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Box/Box.js